import { useState, useEffect } from "react";
import { useSnapshotWhere } from "../../hooks/useSnapshotWhere";
import Spinner from "../../components/Spinner";
import Table from "./components/Table.js";
import Modal from "../../components/Modal/index.js";
import Form from "../../components/Form/index.js";

function Platform({ user }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [sended, setSended] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(0);
  const [approvedRequest, setApprovedRequest] = useState(0);

  const [step, setStep] = useState(0);
  const [data, setData] = useState({
    knowMoney: true,
    ammount: "10000000",
    month: "12",
    expedition: "",
    name: "",
    lastName: "",
    company: "",
    NIT: "",
    address: "",
    cellphone: "",
    identity: "",
  });

  const [files, setFiles] = useState({
    cert_laboral: "",
    comp_nomina: "",
    fot_cedula: "",
    dec_renta: "",
  });
  const { data: dataUser, isFetching } = useSnapshotWhere("users", {
    filter: {
      firstCondition: "id",
      secondCondition: "==",
      thirdCondition: user.uid,
    },
  });

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const getThemeColors = () => {
    if (hostname === "creditos.sofia.com.co") {
      return {
        primary: "bg-gray-900 hover:bg-gray-800",
        text: "text-gray-900",
        accent: "bg-gray-100",
      };
    }
    return {
      primary: "bg-[#49b0a8] hover:bg-[#3a8a84]",
      text: "text-[#49b0a8]",
      accent: "bg-[#49b0a8]/10",
    };
  };

  const theme = getThemeColors();

  return (
    <>
      <Modal showModal={isOpen} setShowModal={() => setIsOpen(false)}>
        <Form
          setSended={setSended}
          sended={sended}
          data={data}
          setData={setData}
          setFiles={setFiles}
          files={files}
          step={step}
          setStep={setStep}
          admin
        />
      </Modal>
      <div className="space-y-6">
        {/* Header Section */}
        <div
          className={`transition-all duration-700 ease-out ${
            isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div className="space-y-1">
              <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
                Solicitudes de Crédito
              </h1>
              <p className="text-gray-600">
                Gestiona y revisa todas las solicitudes de crédito pendientes
              </p>
            </div>

            <button
              className={`
              group relative overflow-hidden ${theme.primary} text-white px-6 py-3 rounded-xl
              font-medium transition-all duration-300 ease-out transform hover:scale-105 hover:shadow-lg
              focus:outline-none focus:ring-4 focus:ring-blue-500/20 active:scale-95
              flex items-center gap-2 min-w-fit
            `}
              onClick={() => setIsOpen(true)}
            >
              {/* Background animation */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>

              {/* Plus icon */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                className="relative z-10 transition-transform duration-300 group-hover:rotate-90"
              >
                <path
                  d="M12 5v14M5 12h14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="relative z-10">Agregar Solicitud</span>
            </button>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${theme.accent}`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={theme.text}
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Pendientes</p>
                  <p className="text-xl font-bold text-gray-900">
                    {pendingRequests === 0 ? "--" : pendingRequests}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-green-100">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-green-600"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Aprobadas</p>
                  <p className="text-xl font-bold text-gray-900">
                    {approvedRequest === 0 ? "--" : approvedRequest}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-red-100">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6 18L18 6M6 6l12 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-red-600"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Rechazadas</p>
                  <p className="text-xl font-bold text-gray-900">0</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div
          className={`transition-all duration-700 ease-out delay-200 ${
            isLoaded ? "opacity-100" : "opacity-0 "
          }`}
        >
          {isFetching ? (
            <div className="flex items-center justify-center py-12">
              <div className="text-center space-y-4">
                <Spinner />
                <p className="text-gray-600">Cargando solicitudes...</p>
              </div>
            </div>
          ) : (
            <Table
              setPendingRequests={setPendingRequests}
              setApprovedRequest={setApprovedRequest}
              user={dataUser}
              isFetchingUser={isFetching}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Platform;
